import _ from "lodash";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { MDBIcon, MDBCardBody, MDBSpinner } from "mdbreact";

import { useAuth } from "hooks/useAuth.js";
import useModal from "hooks/useModal";

import { fetchContractActivityAlert } from "actions/contracts/contractActivityAlertActions";

import SectionHeaderMenu from "components/nav/SectionHeaderMenu";
import Table from "components/common/tables/Table";
import Modal from "components/common/Modal";
import EmptyList from "components/common/EmptyList";

import { isUserNotReadOnly } from "utils/authUtils";
import ContractActivityAlertDelete from "./ContractActivityAlertDelete";

const ContractActivityAlertList = () => {
  const {
    modalOpen,
    headerText,
    setHeaderText,
    formId,
    setFooter,
    setActions,
    selected,
    setSelected,
    setModalState
  } = useModal();

  const auth = useAuth();
  const dispatch = useDispatch();

  const { activityAlertsAvailable, lastAction, loading } = useSelector(
    state => state.contractActivityAlerts
  );

  useEffect(() => {
    dispatch(fetchContractActivityAlert());
  }, [dispatch]);

  // local state
  const [tableData, setTableData] = useState({
    columns: [
      {
        label: "#",
        field: "id",
        sort: "desc"
      },
      {
        label: "Email",
        field: "email",
        sort: "desc",
        minimal: "sm"
      },
      {
        label: "Contract Location",
        field: "contract_location.name",
        sort: "desc",
        minimal: "sm"
      },
      {
        label: "Contract Status",
        field: "contract_status.name",
        sort: "desc",
        minimal: "sm"
      },
      {
        label: "Contract Type",
        field: "contract_type.name",
        sort: "desc",
        minimal: "sm"
      },
      {
        label: "",
        field: "buttons",
        sort: "disabled"
      }
    ]
  });

  const toggleModal = (e, type, item) => {
    if (e) e.preventDefault();

    if (type === "delete") {
      setHeaderText("Delete Contract Activity Delete");
      setFooter(true);
      setActions([
        {
          text: "Delete",
          color: "danger",
          additionalProps: {
            form: formId,
            type: "submit"
          }
        }
      ]);
      setSelected(item);
    }

    if (type) {
      setModalState(true);
    } else {
      setModalState(false);
    }
  };

  const fetchTableLink = useCallback((type, item) => {
    switch (type) {
      case "show":
        return `/admin/contracts/activity-alerts/${item.id}`;
      case "edit":
        return `/admin/contracts/activity-alerts/${item.id}/edit`;
      default:
        return null;
    }
  }, []);

  const sectionHeaderMenu = {
    order: 2,
    show: true,
    linkItems: [
      {
        name: (
          <>
            <MDBIcon icon="fas fa-plus" /> Add Contract Activity Alert
          </>
        ),
        url: "/admin/contracts/activity-alerts/new",
        additionalProps: {
          active: true
        }
      }
    ]
  };

  const renderTable = () => {
    if (loading) {
      return <MDBSpinner />;
    }
    if (_.size(activityAlertsAvailable)) {
      return (
        <Table
          section="Contract Activity Alert"
          tableData={tableData}
          setTableData={setTableData}
          rowData={activityAlertsAvailable}
          sort={["id", "desc"]}
          fetchTableLink={fetchTableLink}
          toggleModal={toggleModal}
          updatedState={lastAction}
          clickableRow
          downloadableCSV
          linkToPage
          showButton
          editButton={isUserNotReadOnly(auth?.user?.user_level) ?? false}
          deleteButton={auth?.user?.is_admin ?? false}
        />
      );
    } else if (_.isEmpty(activityAlertsAvailable)) {
      return (
        <EmptyList
          name="contract activity alert"
          namePlural="contract activity alerts"
          userRole={auth?.user?.user_level}
          createElement={
            <Link to="/admin/contracts/activity-alerts/new">Create</Link>
          }
        />
      );
    }
    return "";
  };
  return (
    <>
      <SectionHeaderMenu menuData={sectionHeaderMenu} />
      <MDBCardBody>{renderTable()}</MDBCardBody>
      {auth?.user?.is_admin ? (
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          headerText={headerText}
          includeFooter={true}
          actionButtons={[
            {
              text: "Delete",
              color: "danger",
              additionalProps: {
                form: formId,
                type: "submit"
              }
            }
          ]}
        >
          <ContractActivityAlertDelete
            formId={formId}
            selected={selected}
            closeModal={() => setModalState(false)}
          />
        </Modal>
      ) : (
        ""
      )}
    </>
  );
};

export default ContractActivityAlertList;
